import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  TCreditCardFormSchema,
  creditCardFormSchema,
} from './CreditCardForm.schema';

export function useCreditCardForm(defaultValues?: TCreditCardFormSchema) {
  return useForm<TCreditCardFormSchema>({
    defaultValues: defaultValues ?? {
      number: {
        empty: true,
        complete: false,
        error: '',
      },
      expiry: {
        empty: true,
        complete: false,
        error: '',
      },
      cvc: {
        empty: true,
        complete: false,
        error: '',
      },
      cardHolderName: '',
      zipCode: '',
    },
    resolver: zodResolver(creditCardFormSchema),
  });
}
